import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';

class Timeline {
  constructor({
    id, customerID, poolID, type, action, data, created, userEmail, branchID,
  }) {
    this.id = id;
    this.customerID = customerID;
    this.poolID = poolID || '';
    this.type = type;
    this.action = action;
    this.data = data;
    this.userEmail = userEmail || '';
    this.branchID = branchID || null;
    this.created = created && moment(created);
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      CustomerID: this.customerID,
      PoolID: this.poolID,
      Type: this.type,
      Action: this.action,
      BranchID: this.branchID,
      UserEmailer: this.userEmail,
      Data: JSON.stringify(this.data),
      Created: this.created,
    };
  }

  static fromApiFormat(api) {
    let parsedData;

    try {
      parsedData = JSON.parse(api.Data);
      try {
        if (parsedData && parsedData.contactsEmailed) {
          parsedData.contactsEmailed = JSON.parse(parsedData.contactsEmailed);
        }
        if (parsedData && parsedData.changes && typeof parsedData.changes === 'string') {
          parsedData.changes = JSON.parse(parsedData.changes);
        }
        if (parsedData && typeof parsedData.data && typeof parsedData.data === 'string' & parsedData.data[0] === '{') {
          parsedData.data = JSON.parse(parsedData.data);
        }
      } catch (e) {
        console.log(e);
      }
    } catch (e) {
      console.log(e);
      console.log(api.Data);
      parsedData = api.Data;
    }
    return new Timeline({
      id: api.ID,
      customerID: api.CustomerID,
      poolID: api.PoolID,
      type: api.Type,
      action: api.Action,
      userEmail: api.UserEmail,
      branchID: api.BranchID,
      data: parsedData,
      created: moment(api.Created),
    });
  }
}

export default Timeline;
